var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hina-input-number",style:({ width: _vm.width })},[_c('el-input-number',_vm._b({attrs:{"controls":false},on:{"change":_vm.handleChange},model:{value:(_vm.v),callback:function ($$v) {_vm.v=$$v},expression:"v"}},'el-input-number',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }